var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{attrs:{"breadcrumb":_vm.breadcrumb},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Сбросить пароль")]},proxy:true},{key:"nav",fn:function(){return [_c('nav-tab')]},proxy:true}])},[_c('password-form',{attrs:{"is-disabled":_vm.isDisabled},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }